import {EducationLevel} from '../../backend/enums/education-level';
import {translations} from '../../i18n/translations';

/**
 * Array with the available genders in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(genders[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const educationLevels: Array<{translation: string; type: EducationLevel}> = [
  {
    translation: translations.education_levels[EducationLevel.NoFormalEducation],
    type: EducationLevel.NoFormalEducation,
  },
  {
    translation: translations.education_levels[EducationLevel.PrimaryEducation],
    type: EducationLevel.PrimaryEducation,
  },
  {
    translation: translations.education_levels[EducationLevel.BasicEducation],
    type: EducationLevel.BasicEducation,
  },
  {
    translation: translations.education_levels[EducationLevel.SecondaryEducation],
    type: EducationLevel.SecondaryEducation,
  },
  {
    translation: translations.education_levels[EducationLevel.VocationalTechnicalTraining],
    type: EducationLevel.VocationalTechnicalTraining,
  },
  {
    translation: translations.education_levels[EducationLevel.BachelorsDegree],
    type: EducationLevel.BachelorsDegree,
  },
  {
    translation: translations.education_levels[EducationLevel.PostgraduateDiploma],
    type: EducationLevel.PostgraduateDiploma,
  },
  {
    translation: translations.education_levels[EducationLevel.MastersDegree],
    type: EducationLevel.MastersDegree,
  },
  {
    translation: translations.education_levels[EducationLevel.DoctoratePhd],
    type: EducationLevel.DoctoratePhd,
  },
  {translation: translations.education_levels[EducationLevel.Other], type: EducationLevel.Other},
];
